import * as React from 'react'

import { reportModalPageView } from '../../../../common/analytics/userAnalytics'
import { config } from '../../../../common/config'
import { getCurrentSiteDomain } from '../../../../common/utils/sites'
import MarketHeaderContainer from '../../containers/marketHeaderContainer'
import { Props } from '../../containers/siteHeaderContainer'
import CategoriesMenu from '../categoriesMenu'
import HeadBanner from '../headBanner'
import PageOffLeftMenu from '../pageOffCanvasLeft/pageOffLeftMenu'
import PageOffLeftSearchBar from '../pageOffCanvasLeft/pageOffLeftSearchBar'

import * as styles from './siteHeader.module.css'

const ssoServerHost = config.sso.SERVER_HOST

const SiteHeader = ({
  banners,
  currentSite,
  menuConfig,
  openModal,
  handleSignInSuccess,
  location,
  experiments,
  makeSearchLink
}: Props) => {
  const pageOffLeftMenu = <PageOffLeftMenu items={menuConfig} />
  const pageOffLeftSearchBar = (
    <PageOffLeftSearchBar makeSearchLink={makeSearchLink} />
  )
  const headerConfigs = {
    ssoServerHost,
    rootDomain: `//${getCurrentSiteDomain(currentSite)}`
  }
  const onClickSignIn = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    reportModalPageView({
      title: 'Modal: direct sign in',
      page: '//direct-sign-in'
    })
    openModal({
      type: 'signIn',
      payload: {
        currentSite,
        onSignInSuccess: handleSignInSuccess,
        welcomeMsg: 'Great to have you back!',
        location,
        experiments
      }
    })
  }

  return (
    <div
      className={styles.headerWrapper}
      data-test-selector="global-header-wrapper"
      role="banner"
    >
      <HeadBanner banners={banners} />
      <MarketHeaderContainer
        currentSite={currentSite}
        mobileCategoriesMenu={pageOffLeftMenu}
        mobileCategoriesSearchBar={pageOffLeftSearchBar}
        onClickSignIn={onClickSignIn}
        configs={headerConfigs}
      />

      <div className={styles.headerCategoriesWrapper}>
        <div className={styles.headerCategories}>
          <div className={styles.gridWide}>
            <CategoriesMenu items={menuConfig} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SiteHeader
